import {useQuery} from "@apollo/client";
import snakeCase from "lodash/snakeCase";
import {useState} from "react";
import {FiPlus} from "react-icons/fi";
import {Link} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButtonGroup} from "@/components/dropdownButtonGroup/DropdownButtonGroup.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {AccountUserFormDependencyResult, GQL_ACCOUNTUSER_FORM_DEPENDENCY_QUERY} from "@/lib/queries/accounts.ts";
import {EditUserModalAction} from "@/pages/accounts/edit/EditUserModalAction.tsx";

interface UsersActionBarProps {
  title: string;
}

export const UsersActionBar = ({title}: UsersActionBarProps) => {
  const [show, setShow] = useState(false);
  const {user} = useCurrentUserContext();
  const {data} = useQuery<AccountUserFormDependencyResult>(GQL_ACCOUNTUSER_FORM_DEPENDENCY_QUERY);

  if (!data) return null;

  if (!user?.has_admin_access) {
    return null;
  }

  return (
    <>
      <DropdownButtonGroup title={title} onClick={() => setShow(true)} icon={FiPlus}>
        <DropdownItem onClick={() => setShow(true)}>{title}</DropdownItem>
        <DropdownItem as={Link} to={`${URL_ORIGINAL_WEBSITE}/accounts/user-management/csv`}>
          Export to CSV
        </DropdownItem>
      </DropdownButtonGroup>
      <EditUserModalAction formId={`form_${snakeCase(title)}`} show={show} setShow={setShow} />
    </>
  );
};
